// The values of all types of a product. Falls back to the single type of the product for API
// versions that don't support products with multiple types yet.
function getProductTypeValues(product) {
    if(!product) {
        return [];
    }
    if(product.types) {
        return product.types.map((type) => type.value);
    }
    return product.type ? [product.type.value] : [];
}

export default getProductTypeValues;
